/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Biological sex as reported to the insurer.
 *
 * Mirrors the monolith `GenderEnum`.
 */
export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
